@if (canCaptureSurvey$ | async) {
    <div adaptToolbarContent
         adaptBlockingButtonGroup>
        <button adaptButtonIcon="add"
                [adaptBlockingClick]="captureNewSurvey"
                data-test="add-survey-button">Add survey</button>
    </div>
}

@if (atLeastOneSurvey) {
    <adapt-two-column-page>
        <div left-column
             class="d-flex flex-column">
            <dx-scroll-view>
                <div class="d-flex flex-column gap-3 me-2">
                    @if (ongoingSurveys.length > 0) {
                        <adapt-universal-dashboard-element name="Active survey"
                                                           class="active-surveys"
                                                           data-test="active-surveys">
                            <div class="d-flex flex-column gap-3">
                                @for (survey of ongoingSurveys; track survey) {
                                    <div class="card ongoing-survey-card">
                                        <adapt-display-survey class="w-100"
                                                              [canEdit]="canCaptureSurvey$ | async"
                                                              [survey]="survey"
                                                              data-test="survey-active"
                                                              (surveyChange)="updateData()"></adapt-display-survey>
                                    </div>
                                }
                            </div>
                        </adapt-universal-dashboard-element>
                    }
                    @if (upcomingSurveys.length > 0) {
                        <adapt-universal-dashboard-element name="Upcoming survey"
                                                           data-test="upcoming-surveys">
                            <div class="d-flex flex-column gap-3">
                                @for (survey of upcomingSurveys; track survey) {
                                    <div class="card survey-result-card">
                                        <adapt-display-survey [survey]="survey"
                                                              [canEdit]="canCaptureSurvey$ | async"
                                                              (surveyChange)="updateData()"
                                                              class="w-100"></adapt-display-survey>
                                    </div>
                                }
                            </div>
                        </adapt-universal-dashboard-element>
                    }
                    @if (previousSurveys.length > 0) {
                        <adapt-universal-dashboard-element name="Completed surveys"
                                                           data-test="completed-surveys">
                            <div class="d-flex flex-column gap-3">
                                @for (survey of previousSurveys; track survey) {
                                    <adapt-display-survey-result [survey]="survey"
                                                                 [allowRestore]="canCaptureSurvey$ | async"
                                                                 (surveyDeleted)="updateData()"></adapt-display-survey-result>
                                }
                            </div>
                        </adapt-universal-dashboard-element>
                    }
                </div>
            </dx-scroll-view>
        </div>
        <div right-column>
            <adapt-universal-dashboard-element name="{{ surveyTypeLabel }} history">
                <ng-container adapt-dashboard-title-buttons>
                    @if (previousSurveys.length > 0) {
                        <a [routerLink]="analysePageObj?.path"
                           [queryParams]="analysePageObj?.queryParams"
                           adaptButtonIcon="fal fa-fw fa-chart-bar"
                           class="btn"
                           data-test="analyse-survey-button">Analyse</a>
                    }
                </ng-container>
                <div class="chart-wrapper">
                    @if (previousSurveys.length > 0) {
                        <adapt-display-survey-history [surveys]="previousSurveys"> </adapt-display-survey-history>
                    } @else {
                        There are no completed surveys
                    }
                </div>
            </adapt-universal-dashboard-element>
        </div>
    </adapt-two-column-page>
} @else {
    @if (isInitialised) {
        <adapt-call-to-action [learnMoreUrl]="learnMoreUrl$ | async">
            <adapt-call-to-action-title>{{ surveyTypeLabel }}</adapt-call-to-action-title>
            <ng-container [ngTemplateOutlet]="callToActionTextTemplate"></ng-container>
            @if (canCaptureSurvey$ | async) {
                <button adaptCallToActionButton
                        adaptButtonIcon="add"
                        [adaptBlockingClick]="captureNewSurvey">Add survey</button>
            }
        </adapt-call-to-action>
    }
}
